module.exports = __webpack_public_path__ + "img/yacht-2.47f38c61.jpg";